import ACTION_TYPE from '../../store/ACTION_TYPE';
import createReducerFunction from '../../store/reducerCreator';

interface State {
    appId?: string;
    name?: string;
}

interface Action {
    type: ACTION_TYPE.OPEN_REMOVE | ACTION_TYPE.CLOSE_REMOVE;
    appId?: string;
    name?: string;
}

const initialState: State = {};

export default createReducerFunction<State, Action>({
    initialState,
    reducers: {
        [ACTION_TYPE.OPEN_REMOVE]: initAppRemove,
        [ACTION_TYPE.CLOSE_REMOVE]: () => initialState,
    },
});

function initAppRemove(state: State, { appId, name }: Action): State {
    return {
        appId,
        name,
    };
}
